export enum UserActionType {
  LOGIN_USER = 'LOGIN_USER',
  LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE',
  SET_USER = 'SET_USER',
  CLEAR_USER = 'CLEAR_USER',
}
